import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { RequestSendMailDto } from "../dto/attendance-itcs.dto";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class AttendanceItcsApi {
    private service: string = '';
    private model: string = 'AttendanceITCSReport';

    constructor(
        private nestApiProvider: NestApiProvider
    ) {
    }

    public downloadExcel(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: any = payload || {};
        const urlParams: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.requestBlob<Blob>(method, url, params);
    }


    public preview(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'preview';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public downloadPdf(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: any = payload;
        const urlParams: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.requestBlob<Blob>(method, url, params);
    }

    public downloadexcel(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'downloadexcel';
        const params: any = payload;
        const urlParams: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.requestBlob<Blob>(method, url, params);
    }

    public reportSendEmailExcel(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public reportSendEmailPdf(payload: RequestSendMailDto) {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-itcs.api.ts